import { Grid, Typography } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import { SpaceBetweenBox } from "components/GeneralStyled";

function BorrowInfo({ borrowAmountMax, selectedCoin }) {
  return (
    <Grid item xs={12}>
      <SpaceBetweenBox>
        <Typography color="text.main" variant="h6">
          کارمزد ساعتی
        </Typography>

        <Typography color="text.main" variant="h6" textAlign="end">
          {borrowAmountMax?.borrowInterestHourlyRate || 0}
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          مقدار قرض گرفته شده
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={borrowAmountMax?.borrowedAmount || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          حداقل مقدار قرض
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={selectedCoin?.minimumBorrowAmount || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>

      <SpaceBetweenBox>
        <Typography color="text.secondary" variant="h6">
          حداکثر مقدار قرض
        </Typography>

        <Typography color="text.secondary" variant="h6" textAlign="end">
          <NumberFormats value={borrowAmountMax?.borrowAmountMax || 0} />
          {""} {selectedCoin?.name}
        </Typography>
      </SpaceBetweenBox>
    </Grid>
  );
}

export default BorrowInfo;
